export class TestUserAnswer {

    public relations = ['answer.question', 'user'];

    public names = {
        test_answer_id: (data) => data.answer?.question?.title + '->' + data.answer?.title,
        user_id: (data) => {
            if(!data.user){
                return 'нет';
            }
            return data.user.f + ' ' + data.user.i + ' '  + data.user.o;
        },
    }
}
